export const translate = {
    methods: {
        translate(key){
            if ( !window.$translations[key] )
            {
                return key;
            }

            return window.$translations[key];
        }
    }
}